import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildTrainingRequestsDatatableFilter,
  useTrainingRequestsDatatable,
} from 'generated/resources/datatable.graphql'
import { ApplicantForRequestsDataTableFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export const applicantFilter = (
  source: ReturnType<typeof useTrainingRequestsDatatable>,
  trainingRequests: ApplicantForRequestsDataTableFragment[]
) => {
  const uniqueAuthorsMap = new Map<string, ApplicantForRequestsDataTableFragment['author']>()
  trainingRequests.forEach((trainingRequest) => {
    const author = trainingRequest.author
    if (author && author.id && !uniqueAuthorsMap.has(author.id)) {
      uniqueAuthorsMap.set(author.id, author)
    }
  })
  const uniqueAuthors = Array.from(uniqueAuthorsMap.values())

  const options = uniqueAuthors.map((author) => {
    const name = author ? author.fullName : ''
    const avatarUrl = buildUrl(author?.avatar)
    return {
      label: name,
      value: author?.id ?? '',
      component: (
        <Box flexDirection="row" alignItems="center" gap="s8">
          <Avatar label={name} size="s32" url={avatarUrl} />
          <Text.Normal weight="medium">{name}</Text.Normal>
        </Box>
      ),
    }
  })
  return buildTrainingRequestsDatatableFilter(source, {
    type: FilterType.Id,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'applicantFilter',
    path: 'authorId',
    title: i18n.t('trainings.training_requests.requests.datatable.filters.applicant'),
    onUpdateValue: () => {
      track(trackingEvents.training.trainingRequest.filterMyRequests, { filter_used: 'Applicant' })
    },
  })
}
